import lazyload from 'app/libs/lazyload';

export default lazyload(() => import('./LayerComm'));
